import { FORGOT_PASSWORD } from "../../constants/forgot-password.constants";

const initialState = {
  loading: false,
  data: false,
  error: '',
};

export function forgotPassword(state = initialState, action: any) {
  switch (action.type) {
    case FORGOT_PASSWORD.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        data: false,
        error: '',
      };
    case FORGOT_PASSWORD.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        data: true,
        loading: false,
        error: '',
      };
    case FORGOT_PASSWORD.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        data: false,
        error: action.error,
      };
    case FORGOT_PASSWORD.FORGOT_PASSWORD_CLEAR:
      return {
        ...state,
        loading: false,
        data: false,
        error: '',
      };
    default:
      return state;
  }
}
